import { Header              } from "../../main_components/header.js";
import { Loading             } from "../../main_components/loading.js";
import { ViewProductBody     } from "./view_product_body.js";
import { useState, useEffect } from "react";
export const ViewProduct = ( props ) => {
    const { loadingDuration } = props;
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ toggle,   setToggle   ] = useState(true);
    useEffect(() => {
        window.onload = _=> setIsLoaded(true);
        setTimeout(_=> {
            setIsLoaded(true);
            setTimeout(_=>{ setToggle(false) }, 500);
            }, loadingDuration);
    }, []);
    return (
        <>
            { toggle && <Loading page={ "View Product" } isLoaded={ isLoaded }/> }
            <Header link={ "Products > View_Product" }/>
            <ViewProductBody />
        </>
    );
};